import $http from '../../axios-instance';
import Swal from 'sweetalert2';
import {getAcls, validarPermisoComponente} from '../../plugins/acl';

import VueRouter from 'vue-router';
import {dispatch} from 'rxjs/internal/observable/pairs';
import { dataInitialHistoryUpdateProducts } from './state';

/**
 * Método para obtener los estados de un producto químico.
 *
 * @param {*} param0
 */
export async function getEstados({commit}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('controles/8')
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('cargarEstados', response.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            console.log(error);
        });
}

/**
 * Método para obtener Existe o No existe de un producto químico.
 *
 * @param {*} param0
 */
export async function getExisteNoExiste({commit}) {
    await $http.get('controles/15')
        .then((response) => {
            commit('CargarExisteNoExiste', response.data);
        })
        .catch((error) => {
            console.log(error);
        });

}

/**
 * Método para obtener la información de un producto químico en específico.
 *
 * @param {*} param0
 * @param {*} id id del producto químico.
 */
export async function getProducto({state, commit, dispatch}, id) {

    commit('dashboard/load', true, {root: true});

    await $http.post(`adm_productos/mostrar/${id}`)
        .then(async (response) => {
            commit('dashboard/load', false, {root: true});
            commit('setProduct', response.data.producto);
            commit('setPago', response.data.pago);

            if (response.data.producto[0].fabricante != null) {
                commit('establecerFabricantesFiltro', [response.data.producto[0].fabricante]);
            }

            if (state.selectedProduct.temporal) {
                await dispatch('fetchEmpresasProveedor');
            }
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            commit('productError', error.message);
        });
}

/**
 * Método para guardar un producto químico.
 *
 * @param {*} param0
 */
export async function guardaProducto({dispatch,commit, state}) {
    if (validarPermisoComponente('crear-productos')) {
        commit('dashboard/load', true, {root: true});
        await $http.post('adm_productos/crear', state.selectedProduct)
            .then(async (response) => {
                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                state.error = false;
                commit('guardaProducto', state);
                state.selectedProduct.Idproducto = response.data.Idproducto;
                if (state.selectedProduct.modulo_creacion == 'analisis-riesgos'){
                    dispatch('analysis/getProductById', response.data.Idproducto, {root: true});
                    commit('analysis/setProductId', response.data.Idproducto, {root: true});
                }
            })
            .catch(async (error) => {
                commit('dashboard/load', false, {root: true});
                state.error = true;
                await Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: error.message + '<br> ' + error.error,
                    timer: 5000
                });
            });
    }
}

/**
 * Método para guardar un producto químico.
 *
 * @param {*} param0
 * @param asignar
 */
export async function aprobarProductoTemporal({state, commit}, asignar = 0) {

    let html = '<p>Está seguro de aprobar el producto?</p>';

    if (asignar && !!state.empresas_proveedor.length){

        html = '<p>Está seguro de aprobar el producto y asignarlo a las siguientes empresas?</p>';

        state.empresas_proveedor.map(empresa => {
            html += '<div>' + empresa.nombre + '</div>';
        })
    }

    return await new Promise(async (resolve, reject) => {
        await Swal.fire({
            title: 'Aprobación de producto',
            html: html,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Si'
        }).then(async (result) => {
            if (result.value) {

                let data = {
                    asignar,
                    empresas: state.empresas_proveedor
                };

                commit('dashboard/load', true, {root: true});

                await $http.post('adm_productos/aprobar_temporal/' + state.selectedProduct.id, data)
                    .then((response) => {
                        Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: 'Cambios aprobados correctamente',
                            showConfirmButton: false,
                            timer: 2000
                        });
                        commit('dashboard/load', false, {root: true});
                        resolve();
                    })
                    .catch((error) => {
                        state.error = true;
                        commit('dashboard/load', false, {root: true});
                        Swal.fire({
                            position: 'center',
                            icon: 'error',
                            title: error.message + '<br> ' + error.error,
                            timer: 5000
                        });
                        reject();
                    });
            } else {
                reject();
            }
        });
    });
}

/**
 * Método para actualizar un producto químico en especíco.
 *
 * @param {*} param0
 * @param {*} id id del producto químico.
 */
export async function actualizaProducto({state, commit}, id) {
    if (validarPermisoComponente('editar-productos')) {
        commit('dashboard/load', true, {root: true});
        await $http.put(`adm_productos/editar/${id}`, state.selectedProduct)
            .then(async (response) => {
                commit('dashboard/load', false, {root: true});
                await Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Muy bien!',
                    text: response.data.message,
                    showConfirmButton: false,
                    timer: 2000
                });
                state.error = false;
                await this.getProducto(state.selectedProduct.Idproducto);
            })
            .catch(async (error) => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Método para actualizar un producto químico en especíco.
 *
 * @param {*} param0
 * @param {*} id id del producto químico.
 */
export async function desactivarProducto({state, dispatch}, id) {
    await $http.put(`adm_productos/desactivar/${id}`)
        .then((response) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            });
            state.error = false;
            dispatch('getProductos');
        })
        .catch((error) => {
            console.log(error);
            //commit('productError', error.message)
        });
}

/**
 * Método para obtener todos los productos químicos registrados en el sistema.
 *
 * @param {*} param0
 * @param {*} requestParameters contiene la información del proceso.
 */
export async function getProductos({commit, state}, requestParameters = {params: state.filtro}) {
    let isValidFilter = false;
    if (!state.esEmpresaContratista) isValidFilter = true;
    else {
        if (state.filtro.nombre || state.filtro.id_fabricante) isValidFilter = true;
        else if (state.filtro.empresa || state.filtro.empresa && state.filtro.contratista) isValidFilter = true;
    }

    if (!isValidFilter) {
        Swal.fire({
            position: 'center',
            icon: 'info',
            title: 'Faltan datos para realizar la búsqueda',
            text: 'Debe ingresar el nombre del producto a buscar y seleccionar un fabricante.',
        });
        return false;
    }

    commit('dashboard/load', true, { root: true });
    await $http.get('prod_products', requestParameters)
        .then((response) => {
            commit('dashboard/load', false, { root: true });
            commit('setProductos', response.data.productos);
            commit('setProductosContratistas', response.data.productos_contratistas);
            commit('setProductosTemporales', response.data.productos_temporales);
        })
        .catch(() => { })
        .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Método para obtener todos los productos químicos asignados a una empresa.
 *
 * @param {*} param0
 * @param {*} requestParameters contiene la información del proceso.
 */
export async function getProductosEmpresa({commit, state}, requestParameters = {params: state.filtro}) {
    commit('dashboard/load', true, {root: true});

    await $http.get('productos', requestParameters)
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setQr', response.data);
            commit('setProductos', response.data.productos);
            commit('setProductosContratistas', response.data.productos_contratistas);
            commit('setProductosTemporales', response.data.productos_temporales);
        })
        .catch(() => commit('dashboard/load', false, {root: true}));
}

/**
 * Método para obtener todas el empresas registradas en el sistema.
 *
 * @param {*} param0
 * @param {*} query contiene parametros del proceso.
 */
export async function getEmpresaFiltro({commit, state, rootState}, data) {
    return await new Promise(async (resolve, reject) => {
        if (!rootState.dashboard.cargando_datos_select) {
            commit('dashboard/setCargandoDatos', true, {root: true});

            await $http.get('/empresas/lista', {params: data})
                .then((response) => {
                    commit('setListaEmpresa', response.data);
                    commit('dashboard/setCargandoDatos', false, {root: true});
                    state.error = false;
                    resolve();
                })
                .catch((error) => {
                    commit('mensajeError', error.message);
                    commit('dashboard/setCargandoDatos', false, {root: true});
                    reject([]);
                });
        }
    });
}

export async function listaTipoSeguimiento({dispatch, state, rootState, commit}) {
    await dispatch('tipoSeguimiento/listarTipoSeguimiento', {}, {root: true});
    commit('setListarTipoSeguimiento', rootState.tipoSeguimiento.tipoSeguimientos);
}

export async function getEmpresaFiltroInventario({dispatch, state, rootState, commit}) {
    if (state.empresas.length == 0) {
        await dispatch('getEmpresaFiltro');
    }
}

/**
 * Método para obtener todos los tipos de productos registrados.
 *
 * @param {*} param0
 * @author Santiago Echeverri
 */
export async function cargarTipoProducto({commit, state}) {
    commit('dashboard/load', true, {root: true});
    await $http.get('/controles/19')
        .then((response) => {
            commit('dashboard/load', false, {root: true});
            commit('setTipoProductos', response.data);
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            commit('mensajeError', error.message);
        });
}

/**
 * Método para obtener las áreas de una empresa en específico.
 *
 * @param {*} param0
 * @param {*} query contiene información del proceso.
 */
export async function getAreasFiltro({commit, state}, query) {
    await $http.get(`empresas/areas/${state.filtro.empresa}`, {params: {nombre: query}})
        .then((response) => {

            commit('setListaAreas', response.data);
            state.error = false;
        })
        .catch((error) => {
            commit('mensajeError', error.message);
        });
}

/**
 * Método para obtener las áreas de una empresa en específico.
 *
 * @param {*} param0
 * @param {*} query contiene información del proceso.
 */
export async function getBasesFiltro({commit, state}, query) {
    await $http.get(`empresas/bases/${state.filtro.empresa}`, {params: {nombre: query}})
        .then((response) => {
            commit('setListaBases', response.data);
            state.error = false;
        })
        .catch((error) => {
            commit('mensajeError', error.message);
        });
}

/**
 * Método para obteber los campos personalizados de una empresa en específico.
 *
 * @param {*} param0
 */
export async function getCamposPersonalizadosProd({commit, state}) {
    if (!state.campos.includes('data')) {
        commit('dashboard/load', true, {root: true});
        await $http.get(`empresas/campos_personalizados/${state.filtro.empresa}`, {id_empresa: state.filtro.empresa})
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('setListaCampos', response.data);
                state.error = false;
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
                commit('mensajeError', error.message);
            });
    }
}

/**
 * Método para obteber los campos personalizados de una empresa en específico.
 *
 * @param {*} param0
 */
export async function getCamposPersonalizadosEmp({commit, state}) {
    if (state.esAdmin) {

        await $http.get(`adm_productos/campos_personalizados/${state.filtro.empresa}`)
            .then((response) => {
                commit('setListaCampos', response.data);
                state.error = false;
            })
            .catch((error) => {
                commit('mensajeError', error.message);
            });
    } else if (state.esEmpresa) {

        await $http.get(`empresas/campos_personalizados/${state.filtro.empresa}`)
            .then((response) => {
                commit('setListaCampos', response.data);
                state.error = false;
            })
            .catch((error) => {
                commit('mensajeError', error.message);
            });
    }
}

/**
 * Método para obtener un producto químico en específico de una tarjeta de emergencia.
 *
 * @param {*} param0
 * @param {*} id id del producto químico.
 */
export async function getProductoTarjeta({commit, state}, id) {
    await $http.get(`adm_productos/${id}`)
        .then((response) => {

            commit('setProducto', response.data);
        })
        .catch((error) => {
            commit('productError', error.message);
        });
}

/**
 * Método para la paginacion de los productos químicos.
 *
 * @param {*} param0
 * @param {*} page contiene la pagina.
 */
export function setPagePagination({commit, dispatch, state}, page) {
    commit('setPage', parseInt(page));
    if (state.esAdmin || state.esEmpresaContratista || state.esAdminTec) {
        dispatch('getProductos');
    } else if (state.esEmpresa || state.esHse || validarPermisoComponente('visualizar-fds')) {
        dispatch('getProductosEmpresa');
    }
}

export function setPerPagePagination({commit, dispatch, state}, perPage) {
    commit('setPerPage', parseInt(perPage));
    if (state.esAdmin) {
        dispatch('getProductos');
    } else if (state.esEmpresa || state.esHse || validarPermisoComponente('visualizar-fds')) {
        dispatch('getProductosEmpresa');
    }
}

export async function getContratista({commit, dispatch, state}) {

    commit('dashboard/load', true, {root: true});

    await $http.get('contratistas?solo_asignados=1&id_empresa=' + state.filtro.empresa)
        .then((response) => {
            commit('setContratistas', response.data);
            state.error = false;
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
            commit('mensajeError', error.message);
        });
}

/**
 * listar las empresas
 * @param {*} param0
 */
export async function listarUbicacionesEmpresa({dispatch, state, rootState, commit}, id) {
    await dispatch('ubicacion/arbolUbicacionesEmpresa', id, {root: true});
    commit('setUbicacioneEmpresa', rootState.ubicacion.arbolUbicaciones);

    await dispatch('location/arbolUbicacionesEmpresa', id, {root: true});
    commit('setArbolEmpresa', rootState.location.arbolUbicaciones);
}

/**
 * @param state
 * @param commit
 * @returns {Promise<void>}
 */

export async function listarFabricantesLista({state, commit}) {
    let params = {
        params: {
            paginate: false,
            omitir_ocultos: state.esEmpresaContratista
        }
    };

    await $http.get('/fabricantes', params)
        .then((response) => {
            commit('setFabricantes', response.data.fabricantes);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error al cargar fabricantes: ' + error,
                showConfirmButton: false,
                timer: 1500
            });
        });
}

// encargado de autocomplete para fabricantes
export async function obtenerFabricantesFiltro({commit, dispatch}, nombre) {
    dispatch('obtenerFabricantesPeticion', nombre)
        .then(fabricantes => commit('establecerFabricantesFiltro', fabricantes));
}

export async function obtenerFabricantesPeticion({commit, state}, nombre) {

    return await new Promise(async (resolve, reject) => {
        if (!state.cargando_datos_select && nombre && nombre.length > 1) {
            commit('establecerCargandoDatosSelect', true);

            let parametros = {
                params: {
                    nombre: nombre
                }
            };

            commit('dashboard/load', true, {root: true});

            await $http.get('/fabricantes', parametros)
                .then((response) => {
                    commit('dashboard/load', false, {root: true});
                    commit('establecerCargandoDatosSelect', false);
                    resolve(response.data.fabricantes);
                })
                .catch(() => {
                    commit('dashboard/load', false, {root: true});
                    console.warn('No se encontraron fabricantes con el nombre especificado');
                    commit('establecerCargandoDatosSelect', false);
                    reject([]);
                });
        }
    });
}

export async function obtenerEmpresasFiltro({commit, dispatch}, nombre) {
    dispatch('obtenerEmpresasPeticion', nombre)
        .then(empresas => commit('establecerEmpresasFiltro', empresas));
}

/**
 * Obtener empresas desde el back
 */
export async function obtenerEmpresasPeticion({commit, state}, nombre) {

    return await new Promise(async (resolve, reject) => {
        if (!state.cargando_datos_select && nombre && nombre.length > 1) {
            commit('establecerCargandoDatosSelect', true);

            let parametros = {
                params: {
                    nombre: nombre,
                    proveedor: state.filtro.proveedor
                }
            };

            commit('dashboard/load', true, {root: true});

            await $http.get('/empresas/lista', parametros)
                .then((response) => {
                    commit('dashboard/load', false, {root: true});
                    commit('establecerCargandoDatosSelect', false);
                    resolve(response.data.data);
                })
                .catch(() => {
                    commit('dashboard/load', false, {root: true});
                    console.warn('No se encontraron empresas con el nombre especificado');
                    commit('establecerCargandoDatosSelect', false);
                    reject([]);
                });
        }
    });
}

export async function listarFabricantes({dispatch, state}) {

    if (!state.fabricantes.length) {
        await dispatch('listarFabricantesLista');
    }
}

export async function obtenerEmpresas({dispatch, commit, state}, nombre) {

    if (!state.cargando_datos_select && nombre && nombre.length > 1) {
        commit('establecerCargandoDatosSelect', true);

        let parametros = {
            params: {
                nombre: nombre
            }
        };

        await $http.get('/empresas/lista', parametros)
            .then((response) => {
                commit('establecerCargandoDatosSelect', false);
                commit('establecerEmpresas', response.data.data);
            })
            .catch(() => {
                console.warn('No se encontraron empresas con el nombre especificado');
                commit('establecerCargandoDatosSelect', false);
            });
    }
}

/**
 * Obtener Listas por el código del control
 */
export async function obtenerListasPorCodigoControl({commit}, codigo) {
    return new Promise(async (resolve) => {
        if (codigo) {
            commit('dashboard/load', true, {root: true});
            await $http.get(`/adm_general/listas/codigo-control/${codigo}`)
                .then((response) => {
                    commit('dashboard/load', false, {root: true});
                    resolve(response.data.data);
                }).catch(() => {
                    commit('dashboard/load', false, {root: true});
                    resolve([]);
                });
        } else {
            resolve([]);
        }
    });
}

/**
 * Obtener presentaciones
 */
export async function obtenerMotivos({state, commit, dispatch}, id_producto) {
    if (!state.motivos.length) {
        await dispatch('obtenerListasPorCodigoControl', 'MOTDES')
            .then((data) => commit('establecerMotivos', data))
            .catch(() => console.log('Error al obtener las listas'));
    }

    commit('restablecerMotivo');
    commit('establecerIdProductoMotivo', id_producto);
    commit('establecerModalDesbloqueo', true);
}

/**
 * Desbloquear producto
 */
export async function desbloquearProducto({dispatch, commit, state}) {
    commit('dashboard/load', true, {root: true});
    await $http.post('/adm_productos/desbloquear_producto', state.motivo)
        .then(async (response) => {
            commit('restablecerMotivo');
            commit('establecerModalDesbloqueo', false);
            commit('dashboard/load', false, {root: true});
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: response.data.message,
                showConfirmButton: false,
                timer: 1500
            });
        })
        .catch(() => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: 'Error al desbloquear el producto',
                showConfirmButton: false,
                timer: 1500
            });
        });
}

/**
 * Desbloquear producto
 */
export async function bloquearProducto({dispatch, commit, state}, id_producto) {
    if (validarPermisoComponente('bloquear-productos')) {
        await Swal.fire({
            title: 'Bloquear producto',
            text: '¿Está seguro de bloquear el producto?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Si'
        }).then(async (result) => {
            if (result.value) {
                commit('establecerIdProductoMotivo', id_producto);
                commit('dashboard/load', true, {root: true});

                await $http.post('/adm_productos/bloquear_producto', state.motivo)
                    .then(async (response) => {
                        commit('restablecerMotivo');
                        commit('dashboard/load', false, {root: true});
                        await dispatch('getProducto', id_producto);
                        await dispatch('getProductos');
                        await Swal.fire({
                            position: 'center',
                            icon: 'success',
                            title: 'Muy bien!',
                            text: response.data.message,
                            showConfirmButton: false,
                            timer: 1500
                        });
                    })
                    .catch(() => {
                        commit('dashboard/load', false, {root: true});
                        Swal.fire({
                            position: 'center',
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al bloquear el producto',
                            showConfirmButton: false,
                            timer: 1500
                        });
                    });
            }
        });
    }
}

/**
 * Obtener proveedores
 */
export async function fetchProviders({commit, state, rootState}, filter = '') {
    if (filter.length >= 3 && !rootState.dashboard.loading) {

        commit('dashboard/load', true, {root: true});

        let params = {
            filter
        };

        await $http.get('providers', {params})
            .then((response) => {
                commit('setProviders', response.data.data);
                commit('dashboard/load', false, {root: true});
            })
            .catch((error) => {
                commit('dashboard/load', false, {root: true});
            });
    }
}

/**
 * Obtener proveedores
 */
export async function fetchEmpresasProveedor({commit, state}) {
    commit('dashboard/load', true, {root: true});

    await $http.get('company-providers-products/' + state.selectedProduct.id)
        .then((response) => {
            commit('setEmpresasProveedor', response.data.data);
            commit('dashboard/load', false, {root: true});
        })
        .catch((error) => {
            commit('dashboard/load', false, {root: true});
        });
}

/**
 * Obtener las fichas de seguridad de un producto.
 * @param commit
 * @param rootState
 * @param product_id
 * @returns {Promise<void>}
 *
 * @author Luis Almendrales
 */
export async function obtainSafetyDataSheets(
    { commit, rootState },
    product_id
) {
    commit("dashboard/load", true, { root: true });

    await $http
        .get("products/get-attachments/" + product_id)
        .then(response => {
            if (response.data.data.attachments.length === 0) {
                commit("dashboard/load", false, { root: true });
                Swal.fire({
                    position: "center",
                    icon: "warning",
                    title: "Este producto no tiene fichas de seguridad",
                    showConfirmButton: false,
                    timer: 1500
                });
            } else {
                commit("dashboard/load", false, { root: true });
                commit("SetSafetyDataSheets", response.data.data.attachments);
                commit("tareas/setModalAttachments", true, { root: true });
                commit("tareas/setProductSelected", response.data.data.product, { root: true });

            }
        })
        .catch(error => {
            commit("dashboard/load", false, { root: true });
        });
}

/**
 * Cargar detalles de un producto por su ID.
 *
 * @param {*} { state, commit, dispatch }
 * @param {*} id: identificador del producto.
 * @author Fernando Claros
 */
export async function getProductById({ state, commit, dispatch }, id) {
    commit('dashboard/load', true, { root: true });

    await $http.get(`products/${id}`)
        .then(async ({ data: response }) => {

            const { product, payment, show_info, in_use } = response.data;
            const payload =  await {
                ...product,
                adjuntos: product.attachments,
                producto_bloqueo: product.product_lock,
                fabricante: product.manufacturer,
                lista_tipo_producto: product.list_type
            };
            commit('setProduct', payload);
            commit('setPago', payment);
            commit('setShowInfo', {show_info,in_use});

            if (product.manufacturer) commit('establecerFabricantesFiltro', [product.manufacturer]);

            if (state.selectedProduct.temporal) await dispatch('fetchEmpresasProveedor');
        })
        .catch((error) => commit('productError', error.message))
        .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Cargar detalles de un producto por su ID.
 *
 * @param {*} { state, commit, dispatch }
 * @param {*} id: identificador del producto.
 * @author Fernando Claros
 */
export async function getInfoProductById({ state, commit, dispatch }, id) {
    commit('dashboard/load', true, { root: true });

    await $http.get(`products/${id}`)
        .then(async ({ data: response }) => {

            const { product, payment, show_info, in_use } = response.data;
            const payload =  await {
                ...product,
                adjuntos: product.attachments,
                producto_bloqueo: product.product_lock,
                fabricante: product.manufacturer,
                lista_tipo_producto: product.list_type
            };
            commit('setProduct', payload);
            commit('setPago', payment);
            commit('setShowInfo', {show_info,in_use});

            if (product.manufacturer) commit('establecerFabricantesFiltro', [product.manufacturer]);

            if (state.selectedProduct.temporal) await dispatch('fetchEmpresasProveedor');
        })
        .catch((error) => commit('productError', error.message))
        .finally(() => commit('dashboard/load', false, { root: true }));
}

/**
 * Cargar las empresas asignadas y MYS de un producto por su id.
 *
 * @param {*} { commit }
 * @param {*} id: identificador del producto.
 * @author Brandon Torres
 */
export async function getCompanyAssingByIdProduct({ commit }, id) {
    commit('dashboard/load', true, { root: true });

    await $http.get(`product-company/get-companies-by-product/${id}`)
        .then((response) => {
            commit('setCompaniesAssignProduct', response.data.data);
        })
        .catch((error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Error',
                text: 'Error al consultar las empresas',
                showConfirmButton: false,
                timer: 1500
            });
        })
        .finally(() => commit('dashboard/load', false, { root: true }));
}


/**
 * Copiar producto.
 *
 * @param {*} { commit }
 * @param {*} payload: id, name
 * @author Paul Valencia.
 */
export async function saveCopiedProduct({ commit }, payload) {

    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.post(`products/copy-info`, payload);
        return response.data;
    } catch (error) {
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 3000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }

}

/**
 * Enviar PDF de la ficha de seguridad Y Obeter los daros generales del producto.
 * @param {*} { commit }
 * @param {*}  file
 * @returns {Promise<void>}
 */
export async function sendPdfSafetyDataSheet({ commit }, file) {

    if (!file) {
        this.$vue.$alertError("El archivo que intentas procesar esta presentando problemas, vuelve a cargarlo.");
        return null;
    }

    commit('dashboard/load', true, { root: true });
    const formData = new FormData();
    formData.append('file', file);
    try {
        const response = await $http.post('ia/read-pdf', formData);
        commit('dashboard/load', false, { root: true });
        return response.data.data
    } catch (error) {
        commit('dashboard/load', false, { root: true });
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 1500
        });
        return null;
    }
}

/**
 * Buscar fabricantes por nombre y devolver la lista de fabricantes.
 *
 * @param {*} { commit }
 * @param {*} name
 * @returns {Promise<void>}
 */
export async function searchFabricantesByName({ commit }, name) {
    commit('dashboard/load', true, { root: true });
    try {
        const response = await $http.get(`fabricantes?nombre=${name}`);
        commit('dashboard/load', false, { root: true });
        commit('setProducersFilter', response.data.fabricantes);
        return response.data.fabricantes;
    } catch (error) {
        commit('dashboard/load', false, { root: true });
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 1500
        });
        return null;
    }
}

/**
 * Agregar componentes al producto leídos del PDF.
 *
 * @param {*} { commit }
 * @param {*} data - Json con los componentes del producto y el id del producto.
 * @returns {Promise<void>}
 */
export async function addComponentsToProduct({ commit }, data) {
    commit('dashboard/load', true, { root: true });
    try {
        const response = await $http.post('products/add-components-read-pdf', data);
        commit('dashboard/load', false, { root: true });
        commit('resetComponentsReadFds');
        return response.data;
    } catch (error) {
        commit('dashboard/load', false, { root: true });
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 1500
        });
        return null;
    }
}

/**
 * Agregar documento y asignar empresa al producto.
 *
 * @param {*} { commit }
 * @param {json} data - Json con el id del producto y la empresa.
 * @returns {Promise<void>}
 */
export async function addDocumentAndAssignCompany({ commit }, data) {
    commit('dashboard/load', true, { root: true });
    try {
        const newFormData = new FormData();
        for (let key in data) {
            newFormData.append(key, data[key]);
        }
        const response = await $http.post('products/assign-company-and-document', newFormData);
        return response.data;
    } catch (error) {
        Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 1500
        });
        return null;
    } finally {
        commit('dashboard/load', false, { root: true });
    }
}

/**
 * Agregar un producto a los seleccionados.
 *
 * @author Libardo Bolaño
 * @param {*} state contiene los productos seleccionados.
 * @param {number} product contiene el producto a agregar.
 */
export function updateSelecteProducts({commit}, product) {
    commit('updateSelecteProducts',product);
}


/**
 * Eliminda un listado de productos seleccionados
 *
 * @author Libardo Bolaño
 * @param { commit, state, dispatch }
 * @param { number[] } productIds - Listado de identificadores de productos.
*/
export async function deleteProducts({commit, state, dispatch},productIds) {
    if(productIds.length > 0) {
        Swal.fire({
            title: "Eliminar Productos",
            text: "¿Está seguro que desea eliminar los productos seleccionados?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Si, Eliminiar",
        }).then(async (result) => {
            if (result.isConfirmed) {
                commit('dashboard/load', true, { root: true });
                await $http.post('products/delete-products', { product_ids: productIds})
                .then((response) => {
                    if(response.data['data'] !== undefined) {
                        const rProductIds = response.data['data'];
                        const products = state.selectedProducts.filter(e => rProductIds.includes(e.id));
                        const listHtml = `
                            <p>Los siguientes productos no se pueden eliminar dado que estan relacionados con una empresa:</p>
                            <ul>
                            ${products.map(item => `<li>${item.nombre}</li>`).join('')}
                            </ul>
                        `;
                        Swal.fire({
                            position: 'center',
                            icon: 'warning',
                            title: 'Alerta',
                            html: listHtml,
                        });
                    }

                    commit('resetSelecteProducts');
                    dispatch('getProductos');
                })
                .catch((error) => {
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: 'Error',
                        text: error.message
                    });
                })
                .finally(() => commit('dashboard/load', false, { root: true }));
            }
        });
    }else Swal.fire({
        position: 'center',
        icon: 'info',
        text: 'Para ejecutar esta acción debe tener por lo menos un producto seleccionado.'
    });
}

/**
 * Inactivar un producto en el sistema
 *
 * @author Libardo Bolaño
 * @param { commit, dispatch }
 * @param {*} product - producto a inactivar.
*/
export async function deleteProduct({commit, dispatch},product) {
    Swal.fire({
        title: "Eliminar Producto",
        text: "¿Está seguro de eliminar el producto " + product.nombre + " ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Eliminiar",
    }).then(async (result) => {
        if (result.isConfirmed) {
            commit('dashboard/load', true, { root: true });
            await $http.post(`products/delete/${product.id}`, null)
            .then((response) => {
                dispatch('getProductos');
            })
            .catch((error) => {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Error',
                    text: error.message
                });
            })
            .finally(() => commit('dashboard/load', false, { root: true }));
        }
    });
}

/**
 * Método para validar si la licencia del usuario permite agregar mas productos.
 *
 * @param {*} companyId - identficador de la empresa
 */
export async function validateAddProductCompany({commit, state}, companyId) {
    if (validarPermisoComponente('empresas-asignar-productos')) {
        commit('dashboard/load', true, {root: true});

        await $http.get('licenses/validate-license', {params: {company_id:companyId}})
            .then((response) => {
                commit('dashboard/load', false, {root: true});
                commit('setAddProductCompany', response.data.data.is_valid);
                commit('setAvailableQuantity', response.data.data.available_quantity);
            })
            .catch(() => commit('dashboard/load', false, {root: true}));
    } else commit('setAddProductCompany', false);
}

/**
 * Método para que las empresas asignen los productos segun la licencia y los permisos que tengan.
 *
 */
export async function assingProductCompany({commit, state}) {
    const acls = getAcls();
    const findRol = acls.roles.find(x => x == "empresa");
    if (findRol){console.log('ok')}
}

/**
 * Método para obtener los productos que una empresa puede asignar.
 *
 * @param {state, commit}
 * @param {string} search
 */
export async function searchProdustToAssign({commit, state, dispatch},search) {
    if(search.length >= 3)await dispatch("getProductsToAssign", search);
}

/**
 * Método para obtener los productos que una empresa puede asignar.
 *
 * @param {state, commit}
 * @param {string} search
 */
export async function getProductsToAssign({commit, state},search =  null) {
    commit('dashboard/load', true, {root: true});
    const acls = getAcls();

    await $http.get('products/search', {params: {company_id: acls.empresa, search: search}})
    .then((response) => {
        commit('dashboard/load', false, {root: true});
        commit('setProductsToAssing', response.data.data);
    })
    .catch(() => commit('dashboard/load', false, {root: true}));
}

/**
 * Cargar los productos por medio de la plantilla generada en el Inventario.
 *
 * @param Object { companyId, file, action }
 * @return void
 */
export async function upFileToUpdateProducts({ commit }, { companyId, file, action }) {
   
    commit('setResponseUpFileExcelProducts', null);
    commit('dashboard/load', true, { root: true });

    let formData = new FormData();

    formData.append('action', action);
    formData.append('company_id', companyId);
    formData.append('file', file);

    await $http({
            url: `product-company/upload-file-excel/to-update`,
            method: "POST",
            data: formData
        })
        .then(({data: response}) =>{
            commit('setResponseUpFileExcelProducts', response.data)

            let message = "Proceso exitoso.";
            if (response.data && typeof response.data === 'object') {
                message = 'Proceso completado con algunas complicaciones.';
            }

            this.$vue.$alertSuccess(message, 7000);
        })
        .catch((error) => this.$vue.$alertError(error.message, 7000))
        .finally(() => commit("dashboard/load", false, { root: true }));       
}

/**
 * Obtener todos los registros de actualización de inventario por medio de Excel.
 * 
 * @param Object commit
 * @param Object payload --> { current_page, per_page, companyId, currentAction }
 */
export async function getHistoryUpdateProducts({ commit }, payload) {
    commit('setHistoryRegistersProductsLoading', true);

    await $http.get('product-company/upload-file-excel/history', { params: {...payload, page: payload.current_page} })
        .then(({data: response}) => commit('setHistoryRegistersProducts', response.data))
        .catch((error) => this.$vue.$alertError(error.message, 7000))
        .finally(() => commit('setHistoryRegistersProductsLoading', false));
}